import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import client from 'api'


const initialState = {
    fetchingStatus: 'idle',
    fetchingError: undefined as string | undefined,

    objects: [] as any[],
    tenants: [] as any[],
    units: [] as any[],
    mwcodes: [] as any[],
}


export const loadObjects = createAsyncThunk('contractsLookup/loadObjects', async () => {
    const res = await client.get('/api/ixweb/objects/?fields=HDR_ID,OBJNR,NAME,STREET&tenants=1')
    return res.data
})

export const loadTenants = createAsyncThunk('contractsLookup/loadTenants', async (objnr?: number | undefined) => {
    let url = '/api/ixweb/tenants/?fields=HDR_ID,OBJNR,SEARCH_NAME,TENANT_NUMBER'
    if (objnr !== undefined) { url = `${url}&objnr=${objnr}` }
    const res = await client.get(url)
    return res.data
})

export const loadUnits = createAsyncThunk('contractsLookup/loadUnits', async (objnr?: number | undefined) => {
    let url = '/api/ixweb/units/?fields=HDR_ID,OBJNR,UNIT_NUMBER,NAME,TYPE,TYPE_NAME,CITY,STREET'
    if (objnr !== undefined) { url = `${url}&objnr=${objnr}` }
    const res = await client.get(url)
    return res.data
})

export const loadMWCodes = createAsyncThunk('contractsLookup/loadMWCodes', async () => {
    const res = await client.get('/api/ixweb/mwcodes/')
    return res.data
})

const handlePending = (state: any) => {
    state.fetchingStatus = 'pending'
    state.fetchingError = undefined
}

const handleRejected = (state: any, action: any) => {
    state.fetchingStatus = 'error'
    state.fetchingError = action.error.message
}


const contractsLookupSlice = createSlice({
    name: 'contractsLookup',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(loadObjects.pending, handlePending)
        builder.addCase(loadObjects.rejected, handleRejected)
        builder.addCase(loadObjects.fulfilled, (state, action) => {
            state.fetchingStatus = 'idle'
            state.fetchingError = undefined
            state.objects = action.payload
        })

        builder.addCase(loadTenants.pending, handlePending)
        builder.addCase(loadTenants.rejected, handleRejected)
        builder.addCase(loadTenants.fulfilled, (state, action) => {
            state.fetchingStatus = 'idle'
            state.fetchingError = undefined
            state.tenants = action.payload
        })

        builder.addCase(loadUnits.pending, handlePending)
        builder.addCase(loadUnits.rejected, handleRejected)
        builder.addCase(loadUnits.fulfilled, (state, action) => {
            state.fetchingStatus = 'idle'
            state.fetchingError = undefined
            state.units = action.payload
        })

        builder.addCase(loadMWCodes.pending, handlePending)
        builder.addCase(loadMWCodes.rejected, handleRejected)
        builder.addCase(loadMWCodes.fulfilled, (state, action) => {
            state.fetchingStatus = 'idle'
            state.fetchingError = undefined
            state.mwcodes = action.payload
        })
    }
})

export default contractsLookupSlice.reducer
